import qs from 'qs';

let hashQuery = location.hash.replace('#', '').replace('/', '').replace('?', '');
let hashQsObj = qs.parse(hashQuery);
let historyQuery = location.search.replace('?', '');
let historyQsObj = qs.parse(historyQuery);
let qsObj = historyQsObj ? historyQsObj : hashQsObj;

window['$qsObj'] = qsObj;
export default qsObj;
